import React from 'react';
import _ from 'lodash';
import { AccordionContainer } from '../../../../../../../../common/components/accordion/accordion.module';
import BrandMappingLogoComponent from './brand-mapping-logo.component';
import BrandMappingFavIconComponent from './brand-mapping-favIcon.compoonent';

export const BrandMappingLogoInfoComponent = ({
  brandMappings, openConfirmationFav, changeFavImage, onFormFavItemChange, getIsFavRecordDeletable,
  deleteselectedFavIcon, getIsLogoRecordDeletable, faviconSize, openConfirmationLogo, onFormLogoItemChange,
  deleteselectedLogo, logoBackground, changeLogoImage, handleClose, handleOpen
}: any) => {

  return (
    <>
      {_.map(brandMappings, (selectedBrand: any, index: any) => (
        <AccordionContainer
          child={

            <><div className='col-span-full'>
              <AccordionContainer
                child={<div>
                  {_.map(selectedBrand?.Logos, (selectedLogo: any, logoIndex: any) => (
                    <BrandMappingLogoComponent
                      selectedBrand={selectedBrand}
                      logoIndex={logoIndex}
                      changeLogoImage={changeLogoImage}
                      deleteselectedLogo={deleteselectedLogo}
                      handleClose={handleClose}
                      handleOpen={handleOpen}
                      itemIndex={index}
                      onFormLogoItemChange={onFormLogoItemChange}
                      openConfirmationLogo={openConfirmationLogo}
                      selectedLogo={selectedLogo}
                      faviconSize={faviconSize}
                      logoBackground={logoBackground}
                      getIsLogoRecordDeletable={getIsLogoRecordDeletable} />
                  )
                  )}
                </div>}
                expandedPanel="logo"
                headerTitle="Logo Info" />
            </div><div className='col-span-full'>
                <AccordionContainer
                  child={<div>
                    {_.map(selectedBrand?.Favicons, (selectedFavIcon: any, index: any) => (
                      <BrandMappingFavIconComponent
                        selectedBrand={selectedBrand}
                        index={index}
                        changeFavImage={changeFavImage}
                        deleteselectedFavIcon={deleteselectedFavIcon}
                        handleClose={handleClose}
                        handleOpen={handleOpen}
                        itemIndex={index}
                        onFormFavItemChange={onFormFavItemChange}
                        openConfirmationFav={openConfirmationFav}
                        selectedFavIcon={selectedFavIcon}
                        faviconSize={faviconSize}
                        logoBackground={logoBackground}
                        getIsFavRecordDeletable={getIsFavRecordDeletable} />
                    )
                    )}
                  </div>}
                  expandedPanel="FavInfo"
                  headerTitle="Fav Info" />
              </div></>
          }
          expandedPanel="Brand Mappings Logo and Favicon Info"
          headerTitle="Brand Mappings Logo and Favicon Info" />
      ))}
    </>
  )
}

export default BrandMappingLogoInfoComponent;
